import { useNavigate } from "react-router-dom";
import BoothMark from "./BoothMark";
import "./Nav.css";

function Nav() {
  const navigate = useNavigate();

  return (
    <nav aria-label="Main" className="booth-shell booth-nav">
      <a
        href="#top"
        className="booth-nav-mark"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <BoothMark />
      </a>
      <div className="booth-nav-links">
        <a href="#how" className="booth-nav-link">How it works</a>
        <a href="#questions" className="booth-nav-link">Questions</a>
        <a
          href="/auth"
          className="booth-nav-signin"
          onClick={(e) => {
            e.preventDefault();
            navigate("/auth");
          }}
        >
          Sign in
        </a>
        <button type="button" className="booth-btn booth-btn--primary booth-btn--sm" onClick={() => navigate("/auth")}>
          Add your league <span aria-hidden="true">→</span>
        </button>
      </div>
    </nav>
  );
}

export default Nav;
